// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entryId: __t.u64().primaryKey().name("entry_id"),
  kind: __t.string(),
  ref: __t.string(),
  author: __t.identity(),
  text: __t.string(),
  mediaRef: __t.string().name("media_ref"),
  permanent: __t.bool(),
  expiresAt: __t.timestamp().name("expires_at"),
  worldId: __t.u64().name("world_id"),
  at: __t.timestamp(),
});
